export const warrantyImageTypes = [
    'WarrantyTypeNap',
    'WarrantyTypePlus',
    'WarrantyType5Years',
    'WarrantyTypeAsgExtended',
];
